import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { PreguntasFrecuentesComponent } from './pages/preguntas-frecuentes/preguntas-frecuentes.component';
//import { DescargaPolizaComponent } from './pages/descarga-poliza/descarga-poliza.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'cotizador',
    pathMatch: 'full'
  },
  {
    path: 'cotizador',
    loadChildren: () => import('./cotizador-module/cotizador/cotizador-module.module').then(m => m.CotizadorModuleModule)
  },
  {
    path: 'preguntas-frecuentes',
    loadComponent: () => import('./pages/preguntas-frecuentes/preguntas-frecuentes.component').then(m => m.PreguntasFrecuentesComponent)
  },
  {
    path: 'descarga-poliza',
    loadChildren: () => import('./pages/descarga-poliza/descarga-poliza.module').then(m => m.DescargaPolizaModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { enableTracing: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
